import React from 'react';

class ControlSelector extends React.Component {
  constructor(props) {
    super(props);
    this.ulRef = React.createRef();
    this.componentDidUpdateCount = 0;
  }

  animatedScroll(dom, delta) {
    const x0 = dom.scrollLeft;
    const SCROLL_DURATION = 30;
    const stepX = Math.PI / SCROLL_DURATION;
    let stepCount = 0;

    const step = () => {
      if (stepCount < SCROLL_DURATION) {
        window.requestAnimationFrame(step);
        stepCount++;
        dom.scrollTo(
          x0 + 0.25 * delta * Math.pow(1 - Math.cos(stepX * stepCount), 2),
          0
        );
      }
    };
    window.requestAnimationFrame(step);
  }

  scrollLeft() {
    if (this.ulRef.current) this.animatedScroll(this.ulRef.current, -300);
  }

  scrollRight() {
    if (this.ulRef.current) this.animatedScroll(this.ulRef.current, 300);
  }

  componentDidUpdate(prevProps) {
    if (parseInt(prevProps.controlId, 10) !== parseInt(this.props.controlId, 10)) {
      if (this.ulRef.current && this.props.controlId) {
        this.ulRef.current.childNodes.forEach((e) => {
          if (parseInt(e.getAttribute('data-id'), 10) === parseInt(this.props.controlId, 10)) {
            const position =
              e.offsetLeft -
              this.ulRef.current.offsetLeft -
              this.ulRef.current.scrollLeft -
              (this.ulRef.current.offsetWidth / 2 - e.offsetWidth / 2);
            this.animatedScroll(this.ulRef.current, position);
          }
        });
      }
    }
  }

  render() {
    const controlId = parseInt(this.props.controlId, 10);
    const controlList = this.props.controlList || [];
    const { showGeneroSelector } = this.props;

    return (
      <div className={`relative md:max-w-5xl md:mx-auto ${!showGeneroSelector ? 'mt-0 md:mt-0' : 'mt-0'}`}>
        <ul
          ref={this.ulRef}
          className="
            flex flex-nowrap items-stretch gap-2
            justify-start
            overflow-x-auto
            hide-scrollbar md:scrollbar
            snap-x md:snap-none snap-mandatory scroll-smooth
            px-2 py-2 list-none pl-10 pr-10 ml-4
          "
          style={{
            justifyContent: window.innerWidth >= 768 ? 'center' : 'flex-start'
          }}
        >
          
          {controlList.map((control) => {
            if (control.tipo === 'SALIDA') return null;
            const isSelected = parseInt(control.id, 10) === controlId;
            return (
              <li key={control.id} data-id={control.id} className="snap-start flex-none">
                <button
                  onClick={() => this.props.navigateToControl(control.id)}
                  className={[
                    'min-w-[120px] max-w-[150px] px-4 py-2 rounded-md text-center cursor-pointer',
                    'transition-all duration-200 mt-2',
                    isSelected
                      ? 'bg-ccnorte text-white shadow-[0_4px_10px_rgba(0,0,0,0.25)]'
                      : 'ring-1 ring-white/10 text-white hover:text-gray-400'
                  ].join(' ')}
                >

                  <div className="text-sm font-bold font-montserrat leading-none truncate">
                    {control.nombre}
                  </div>
                  <div
                    className={[
                      'mt-1 text-[10px] uppercase tracking-wider leading-tight truncate',
                      isSelected ? 'text-white' : 'text-white/75'
                    ].join(' ')}
                    dangerouslySetInnerHTML={{ __html: control.descripcion || '&nbsp;' }}
                  />
                </button>
              </li>
            );
          })}
          {/* separador fantasma para que no tape el fade en móvil */}
          <li className="flex-none w-2" aria-hidden="true"></li>
        </ul>
      </div>
    );
  }
}

export default ControlSelector;
